module.exports = __webpack_public_path__ + "static/media/image1.0d561ec5.jpg";